const getPrimaryContact = (email, phone) => {
  if (email && String(email).trim().length > 0) {
    return String(email).trim();
  }
  return phone;
};

export const formatL0InfoLabel = (l0Info) => {
  if (!l0Info || typeof l0Info !== "object") {
    return "";
  }
  const fn = l0Info.firstName ?? l0Info.first_name;
  const ln = l0Info.lastName ?? l0Info.last_name;
  const namePart = [fn, ln].filter(Boolean).join(" ").trim();
  const email = l0Info.email ?? l0Info.emailId ?? l0Info.email_id;
  const phone =
    l0Info.phone ?? l0Info.phoneNumber ?? l0Info.phone_number ?? l0Info.mobile;
  const contact = getPrimaryContact(email, phone);
  if (namePart && contact) {
    return `${namePart} , ${contact}`;
  }
  if (namePart) {
    return namePart;
  }
  return (
    l0Info.name ??
    l0Info.fullName ??
    l0Info.full_name ??
    l0Info.displayName ??
    l0Info.display_name ??
    ""
  );
};
